import { render, staticRenderFns } from "./DonutModule.vue?vue&type=template&id=6884076f&scoped=true"
import script from "./DonutModule.vue?vue&type=script&lang=js"
export * from "./DonutModule.vue?vue&type=script&lang=js"
import style0 from "./DonutModule.vue?vue&type=style&index=0&id=6884076f&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884076f",
  null
  
)

export default component.exports